import "./MoodOverviewPage.css";
import React, { useState } from "react";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";

import Modal from "utilities/reusableComponent/Modal/Modal";
import Loader from "utilities/reusableComponent/Loader/Loader";

function AddMood({
    dataMoodIcons, 
    isOpenModal, 
    setOpenModal, 
    teacherUid, 
    childUid,
    refreshMoodLoged,
    setRefreshMoodLoged
}) {
    const [moodSelected, setMoodSelected] = useState(null);
    const [moodComment, setMoodComment] = useState('');
    const [loading, setLoading] = useState(false);

    /**
     * Handle on click selected mood icons
     * @param uid {string} - mood icon uid
     */
    const handleOnClickMood = (uid) => {
        setMoodSelected(uid);
    }

    // Handle on close modal
    const handleCloseModal = () => {
        setOpenModal(false)
        setMoodSelected(null);
    }

    /**
     * Handle on change textarea value 
     * @param event {object} - textarea meta data
     */
    const onTextChange = (event) => {
        setMoodComment(event.target.value)
    }

    // Handle on close modal
    const onSubmitLogMood = async () => {

        // submite data to API 
        setLoading(true);
        const response = await apiRequest({
            requestType: requestType.addTeacherLogMoods,
            payload: {
                data: {
                    user_uid: teacherUid,
                    child_uid: childUid,
                    mood_uid: moodSelected,
                    comment: moodComment
                }
            },
        });
        if (response?.data?.status === 0) {
            setRefreshMoodLoged(refreshMoodLoged + 1);
            setOpenModal(false)
            setMoodSelected(null);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    return (
    <>
        {isOpenModal && (
            <Modal onClose={() => handleCloseModal()} customStyle={'mood-popup'}>
                <div className="">
                    <div className="grid grid-cols-4 gap-5 mt-[50px] mb-[20px] content-center">
                        {dataMoodIcons.map((item, index) => {
                            const borderColor = `border-${item.color}`;
                            const bgColor = `bg-${item.color}/50`;
                            return (
                                <div
                                    key={index}
                                    className={`flex items-start justify-center cursor-pointer border-8 ${borderColor} rounded-[60px] mood-box-shadow ${moodSelected !== null && moodSelected === item.uid ? `${bgColor}` : ''}`}
                                    onClick={() => handleOnClickMood(item.uid)}
                                >
                                    <div className="w-[190px] h-[120px] m-5">
                                        <div className="flex h-[90px] justify-center items-center">
                                            <img
                                                src={item.image_url}
                                                className={`object-contain`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="flex justify-center mt-[10px] text-[22px] font-bold">{item.title}</div>
                                    </div>  
                                </div>
                            );
                        })}
                    </div>

                    {moodSelected !== null && (
                        <div className="justify-center mt-[60px]">
                            <div className="title">
                                <h1>Add a Comment</h1>
                            </div>
                            <div>
                                <p className="text-html font-medium">Write an optional short explanation <br/> about the mood you have observed </p>
                            </div>
                            <div className="text-center">
                                <textarea 
                                    className="rounded-[20px] w-[563px] h-[140px] box-border my-[30px] pl-4 py-[10px] bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color opacity-[0.99] placeholder:text-form-placeholder-color" 
                                    placeholder="Type here..."
                                    onBlur={(event) => onTextChange(event)}
                                >
                                </textarea>
                            </div>
                            <div className="flex justify-center items-center">
                                <div className="rounded-[65px] py-[16px] bg-custom-navy cursor-pointer">
                                    <button 
                                        type="submit" 
                                        className="w-[563px] text-[22px] text-white text-bold"
                                        onClick={() => onSubmitLogMood()}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>    
            </Modal>
        )}
        {loading && <Loader />}
    </>
  );
}

export default AddMood;
